import React, {useContext, useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import {AuthenticationManager} from "../Provider/AuthManager";
import {AuthContext} from "../Provider/AuthProvider";
import {Ajax} from "../Service/ajax";
import {GridLoader} from "react-spinners";
import Swal from "sweetalert2";
export default function LoginView() {
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const { setIsAuthenticated } = useContext(AuthContext);
    const session = sessionStorage.getItem("session");
    const [isChecked, setIsChecked] = useState(false);

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
        if (!isChecked) {
            sessionStorage.setItem('rememberMe', 'true');
        } else {
            sessionStorage.removeItem('rememberMe');
        }
    };
    useEffect(() => {
        const fetchDataAndAuthenticate = async () => {
            setIsLoading(true);

            try {
                const urlSearchParams = new URLSearchParams(window.location.search);
                if(urlSearchParams.has("target") && urlSearchParams.get("target")){
                    if(urlSearchParams.get("target") === "own-page"){
                        sessionStorage.setItem("target_id",urlSearchParams.get("target_id"));
                    }
                    sessionStorage.setItem("target",urlSearchParams.get("target"));
                }

                if (!session) {
                    if (urlSearchParams.has("code") && urlSearchParams.get("code")) {
                        const isAuthenticated = await AuthenticationManager.authenticate(urlSearchParams.get("code"));
                        setIsAuthenticated(isAuthenticated);
                        if (isAuthenticated) {
                            const redirectUrl = sessionStorage.getItem("target");
                            if(redirectUrl === "login"){
                                const {data} = await Ajax.getRequest('/exposed/v1/cmp/solutions?code=SUB');
                                sessionStorage.setItem("solution", JSON.stringify(data));
                                sessionStorage.removeItem("target");
                                navigate("/particulier");
                            }else if(redirectUrl === "subs"){
                                sessionStorage.removeItem("target");
                                navigate("/");
                            }else if(redirectUrl === "own-page"){
                                let tgt = sessionStorage.getItem('target_id');
                                sessionStorage.removeItem('target_cmp');
                                sessionStorage.removeItem("target");
                                sessionStorage.removeItem("ref");
                                navigate(`/${tgt}`);
                            }
                        }
                    }
                } else {
                    const redirectUrl = urlSearchParams.get("target");
                    if(redirectUrl === "login"){
                        const {data} = await Ajax.getRequest('/exposed/v1/cmp/solutions?code=SUB');
                        sessionStorage.setItem("solution", JSON.stringify(data));
                        navigate("/particulier");
                    }else if(redirectUrl === "subs"){
                        navigate("/");
                    }else if(redirectUrl === "own-page"){
                        let tgt = urlSearchParams.get('target_id');
                        navigate(`/${tgt}`);
                    }
                }
            } catch (error) {
                navigate("/error-page", { state: { errorCode: error.response.status } });
            } finally {
                setIsLoading(false);
            }
        };

        fetchDataAndAuthenticate();
    }, []);


    const handleLoginClick = async () => {
        await AuthenticationManager.login();
    };

    return (
        <>
            {isLoading ? (
                <div className="loading-overlay">
                    <div className="loading-spinner">
                        <GridLoader
                            color="#debf66"
                            loading
                            size={15}
                        />
                    </div>
                </div>
            ) : (
                <div className="container-xxl">
                    <div className="authentication-wrapper authentication-basic container-p-y">
                        <div className="authentication-inner">
                            <div className="card">
                                <div className="card-body">
                                    <div className="app-brand justify-content-center">
                                        <div className="mb-2">
                                            <img src={require("../assets/img/illustrations/Netikash subscribe.png")}
                                                 alt="Netiaksh Logo" className="mb-3" style={{width: 200}}/>
                                        </div>
                                    </div>
                                    <h4 className="mb-2 text-netikash">Bienvenue Sur Subscribe!</h4>
                                    <p className="mb-2">Veuillez vous connecter avec votre compte Netikash</p>
                                    <div className="form-check mt-2 mb-2">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={isChecked}
                                            onChange={handleCheckboxChange}
                                            id="rememberMe"
                                        />
                                        <label className="form-check-label" htmlFor="rememberMe">
                                            Se souvenir de moi
                                        </label>
                                    </div>
                                    <div>
                                        <div className="mb-3">
                                            <button
                                                className="btn btn-netikash d-grid w-100"
                                                onClick={handleLoginClick}
                                            >
                                                Se Connecter
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
